import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { sliderSwiperconfig } from '../../../../models';
import { ScreenImage } from '../../../shared';

import { ImagePreviewComponent } from '@monorepo/ui';

@Component({
  selector: 'signgaze-listing-images',
  templateUrl: './listing-images.component.html',
  styleUrls: ['./listing-images.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListingImagesComponent {
  @Input()
  screenImages: ScreenImage[] = [];

  swiperConfig = sliderSwiperconfig;

  constructor(private dialog: MatDialog) {}

  public openDialog(screenIndex: number): void {
    const imageOptions: any = {
      images: this.screenImages,
      index: screenIndex,
    };
    this.dialog.open(ImagePreviewComponent, {
      panelClass: 'full-screen-dialog',
      data: imageOptions,
    });
  }
}
